import React, { useEffect, useState } from "react";
import NoDataFound from "../utilsComponent/noDataFound";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { addDays, format } from "date-fns";
import ListsPagination from "../utilsComponent/ListsPagination";
import {
  DATE_FORMAT,
  ERROR_MESSAGE,
  functionalities,
  GOVT_PRODUCT,
  REGEX,
  SORT_ORDER,
} from "../consts";
import {
  editModeOn,
  getMaxDate,
  sortList,
  validateStartDate,
  validateValueWithEndDate,
} from "../utilFunctions";
import "../scss/animalAttack.scss";
import {
  addNewLossReserve,
  editLossReserve,
  getAllLossReserve,
} from "./masterServiceAPI";
import Loader from "./Loader";
import { HttpStatusCode } from "axios";

function LossReserveMaster(props) {
  const { roleDataCookie, productNames } = props;
  const [lossReserveList, setLossReserveList] = useState([]);
  const [showAddPopover, setShowAddPopover] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [sortedBy, setSortedBy] = useState("endDate");
  const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASC);
  const [isLoading, setLoading] = useState(false);
  const [isPopupLoading, setPopupLoading] = useState(false);
  const [productNameArray, setProductNameArray] = useState(props.productNames);

  const defaultPayload = {
    slno: null,
    createdBy: roleDataCookie?.userID,
    updatedBy: null,
    startDate: null,
    endDate: null,
    lossReserve: 0,
    productId: null,
    productName: null,
  };
  const [lossReservePayload, setLossReservePayload] = useState(defaultPayload);

  useEffect(() => {
    if (props.productNames?.length) {
      setProductNameArray(
        props.productNames.filter(
          (product) => !GOVT_PRODUCT.includes(product?.label)
        )
      );
    }
  }, [productNames]);

  useEffect(() => {
    getLossReserveList();
  }, []);

  const getLossReserveList = async () => {
    const data = await getAllLossReserve();
    setLoading(true);
    if (data?.status === HttpStatusCode.Ok) {
      setLossReserveList(sortList(sortedBy, sortOrder, data?.data));
      setLoading(false);
    } else if (!lossReserveList && lossReserveList.length === 0) {
      toast.error("Failed to get data");
      setLoading(false);
    }
  };

  const handleDateChange = (date, key) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const dat1 = date.getDate().toString().padStart(2, "0");
      setLossReservePayload({
        ...lossReservePayload,
        [key]: `${year}-${month}-${dat1}`,
      });
    }
  };

  const addLossReserveMaster = async () => {
    const sortedList = sortList("endDate", SORT_ORDER.DESC, lossReserveList);
    const validatedStartDateData = validateStartDate(
      sortedList,
      lossReservePayload,
      "startDate",
      "endDate",
      editMode
    );
    if (!lossReservePayload.productId) {
      toast.error("Please select product name.");
      return;
    } else if (!lossReservePayload.lossReserve) {
      toast.error("Please enter loss reserve percentage.");
      return;
    } else if (lossReservePayload.lossReserve > 100) {
      toast.error("Loss reserve can not be greater than 100");
      return;
    } else if (!lossReservePayload.startDate) {
      toast.error("Please select start date.");
      return;
    } else if (!lossReservePayload.endDate) {
      toast.error("Please select end date.");
      return;
    }  else if (
      validateValueWithEndDate(
        sortedList,
        lossReservePayload,
        "lossReserve",
        "endDate",
        editMode
      )
    ) {
      toast.error("Please select different loss reserve value");
      return;
    } else if (validatedStartDateData.isAvailable) {
      toast.error(validatedStartDateData.message);
      return;
    } else {
      const data = {
        ...lossReservePayload,
        productId: lossReservePayload.productId,
        updatedBy: roleDataCookie?.userID,
      };
      if (editMode) {
        setPopupLoading(true);
        const response = await editLossReserve(data);
        if (response?.status === HttpStatusCode.Ok) {
          setPopupLoading(false);
          setEditMode(false);
          setLossReservePayload(defaultPayload);
          getLossReserveList();
          toast.success("Loss reserve updated successfully");
          setShowAddPopover(false);
        } else {
          setPopupLoading(false);
          toast.error(response?.data || ERROR_MESSAGE);
        }
      } else {
        setPopupLoading(true);
        const response = await addNewLossReserve(data);
        if (response?.status === HttpStatusCode.Ok) {
          setPopupLoading(false);
          setLossReservePayload(defaultPayload);
          getLossReserveList();
          toast.success(
            `Loss reserve for ${lossReservePayload?.productName} created successfully`
          );
          setShowAddPopover(false);
        } else {
          setPopupLoading(false);
          toast.error(response?.data || ERROR_MESSAGE);
        }
      }
    }
  };
  const clickedOnEditMode = (data) => {
    const editData = {
      slno: data.slno,
      productId: data.productId,
      productName: data.productName,
      lossReserve: Number(data.lossReserve || 0).toFixed(2),
      startDate: data.startDate,
      endDate: data.endDate,
      createdBy: roleDataCookie?.userID,
    };
    setLossReservePayload(editData);
    setEditMode(true);
    setShowAddPopover(true);
  };

  const handleAdd = () => {
    setShowAddPopover(!showAddPopover);
  };
  const addLossReserve = () => {
    setLossReservePayload(defaultPayload);
    setShowAddPopover(!showAddPopover);
    setEditMode(false);
  };
  const sortingData = (sortedByColumn) => {
    let order = SORT_ORDER.ASC;
    if (sortedByColumn === sortedBy) {
      order = sortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
    }
    setSortedBy(sortedByColumn);
    setSortOrder(order);
    setLossReserveList(sortList(sortedByColumn, order, lossReserveList));
  };

  const getAddPopup = () => {
    return (
      <Modal
        show={showAddPopover}
        isOpen={showAddPopover}
        toggle={handleAdd}
        centered={true}
        backdrop={"static"}
      >
        <ModalHeader>
          {editMode ? <h5>Edit Loss Reserve</h5> : <h5>Add Loss Reserve</h5>}
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleAdd}
          ></button>
        </ModalHeader>
        <ModalBody>
          <div className="form-group mb-3">
            <form action>
              <div className="form-group mb-3">
                <label for="productNameArraySelect" className="form-label">
                  Product Name
                </label>
                <Select
                  id="productNameArraySelect"
                  options={productNameArray}
                  onInputChange={(inputValue) => {
                    const cleanedValue = inputValue.replace(
                      REGEX.ALPHABET_REGEX,
                      ""
                    );
                    return cleanedValue;
                  }}
                  isDisabled={editMode}
                  placeholder="Kshema Product"
                  value={
                    lossReservePayload?.productName
                      ? {
                          value: lossReservePayload.productId,
                          label: lossReservePayload?.productName,
                        }
                      : { label: "Product" }
                  }
                  onChange={(data) => {
                    setLossReservePayload({
                      ...lossReservePayload,
                      productId: data.value,
                      productName: data.label,
                    });
                  }}
                />
              </div>
              <div className="form-group mb-3">
                <label for="lossReservePercentage" className="form-label">
                  Loss Reserve %
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lossReservePercentage"
                  placeholder="Loss Reserve %"
                  onChange={(e) => {
                    let numericValue = e.target.value.replace(
                      REGEX.NUMBER_WITH_DOT,
                      ""
                    );
                    numericValue = numericValue.replace(
                      REGEX.NO_ZERO_START,
                      ""
                    );
                    setLossReservePayload({
                      ...lossReservePayload,
                      lossReserve: isNaN(Number(numericValue))
                        ? 0
                        : numericValue,
                    });
                  }}
                  value={lossReservePayload.lossReserve}
                />
              </div>
              <div className="form-group mb-3">
                <label for="startDate" className="form-label">
                  Start Date
                </label>
                <div className="form-control">
                  <DatePicker
                    id="startDate"
                    selected={
                      lossReservePayload?.startDate &&
                      lossReservePayload?.startDate
                    }
                    onChange={(date) => handleDateChange(date, "startDate")}
                    dateFormat={DATE_FORMAT.DD_MM_YYYY}
                    placeholderText={DATE_FORMAT.DD_MM_YYYY}
                    className="no-border"
                    onKeyDown={(e) => e.preventDefault()}
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={1000}
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <label for="endDate" className="form-label">
                  End Date
                </label>
                <div className="form-control">
                  <DatePicker
                    id="endDate"
                    selected={
                      lossReservePayload?.endDate && lossReservePayload?.endDate
                    }
                    onChange={(date) => handleDateChange(date, "endDate")}
                    dateFormat={DATE_FORMAT.DD_MM_YYYY}
                    placeholderText={DATE_FORMAT.DD_MM_YYYY}
                    className="no-border"
                    onKeyDown={(e) => e.preventDefault()}
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={1000}
                  />
                </div>
              </div>
            </form>
          </div>
        </ModalBody>
        <ModalFooter className="modal-footer">
          <Button
            className="save-button"
            onClick={() => addLossReserveMaster()}
            disabled={isPopupLoading}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  };
  return (
    <section className="p-4">
      <h1 className="headerclaim">Loss Reserve Master</h1>
      <hr className="upper_hr" />
      <div className="outer-box_vendorMasters">
        <div className="div-parent">
          <h2 className="heading_h2Masters">Loss Reserve Master</h2>
          {editModeOn(functionalities.LOSS_RESERVE_MASTER_TAB) && (
            <button
              className="btn btn-success px-4 add-button"
              onClick={() => addLossReserve()}
            >
              <i className="fa fa-plus" aria-hidden="false"></i> Add
            </button>
          )}
          {getAddPopup()}
        </div>
        {lossReserveList && lossReserveList.length > 0 && (
          <>
            <table className="table mt-3 text-left">
              <thead className="row-border">
                <tr>
                  <th className="row-border">S NO.</th>
                  <th className="row-border">
                    Product Name
                    <a
                      className="pointer text-body ms-1"
                      onClick={() => sortingData("productName")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="pointer"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-filter"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg>
                    </a>
                  </th>
                  <th className="row-border">
                    Loss Reserve%
                    <a
                      className="pointer text-body ms-1"
                      onClick={() => sortingData("lossReserve")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="pointer"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-filter"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg>
                    </a>
                  </th>
                  <th className="row-border">Start Date</th>
                  <th className="row-border">End Date</th>
                  {editModeOn(functionalities.LOSS_RESERVE_MASTER_TAB) && (
                    <th className="row-border">Action</th>
                  )}
                </tr>
              </thead>
              <tbody className="row-border">
                {currentItems.map((list, index) => (
                  <tr key={index}>
                    <td className="row-border">{index + 1}</td>
                    <td className="row-border">{list?.productName}</td>
                    <td className="row-border">{Number(list.lossReserve || 0).toFixed(2)}%</td>
                    <td className="row-border">
                      {format(new Date(list.startDate), "dd-MMM-yyyy")}
                    </td>
                    <td className="row-border">
                      {format(new Date(list.endDate), "dd-MMM-yyyy")}
                    </td>
                    {editModeOn(functionalities.LOSS_RESERVE_MASTER_TAB) && (
                      <td
                        onClick={() => {
                          clickedOnEditMode(list);
                        }}
                        className="d-flex align-items-center justify-content-center table-row-bg"
                      >
                        <FontAwesomeIcon
                          icon="fas fa-edit"
                          className="edit_button"
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <ListsPagination
              setCurrentItems={setCurrentItems}
              lists={lossReserveList}
            />
          </>
        )}
        {(!lossReserveList || lossReserveList.length === 0) && !isLoading && (
          <>
            <NoDataFound text="No Data Found" />
          </>
        )}
        {isLoading && <Loader />}
      </div>
    </section>
  );
}

export default LossReserveMaster;
